import React, { useState } from "react";
import { Waypoint } from "react-waypoint";
import CountUp from "react-countup";

const Facts = () => {
  const [countUpInView, setCountUpInView] = useState({
    count1: false,
    count2: false,
    count3: false,
    count4: false,
  });

  const handleEnterViewport = (countName) => {
    setCountUpInView((prevState) => ({
      ...prevState,
      [countName]: true,
    }));
  };

  const handleLeaveViewport = (countName) => {
    setCountUpInView((prevState) => ({
      ...prevState,
      [countName]: false,
    }));
  };

  return (
    <section id="facts" className="facts">
      <div className="container">
        <div className="section-title">
          <h2>Facts</h2>
          <p>
            As a seasoned professional with over 20 years of experience, I have a proven track record of success. With 1320 successful projects completed and more than $30 million in revenue generated, I am committed to delivering exceptional results. My expertise has been recognized through numerous industry awards, reflecting my dedication to excellence and innovation. Explore my portfolio to learn more about how I can help you achieve your goals.
          </p>
        </div>
        <div className="row no-gutters">
          <div className="col-lg-3 col-md-6 d-md-flex align-items-md-stretch">
              <Waypoint
                onEnter={() => handleEnterViewport("count2")}
                onLeave={() => handleLeaveViewport("count2")}
              >
                <div className="count-box">
                  <i className="bi bi-journal-richtext"></i>
                  {countUpInView.count2 && (
                    <CountUp
                      end={1320}
                      duration={1}
                      prefix=""
                      decimals={0}
                      className="purecounter"
                    />
                  )}
                  <p>
                    <strong>Projects</strong>
                    <br />
                    I have successfully completed over one thousand projects, demonstrating a track record of delivering results and meeting client expectations.
                  </p>
                </div>
              </Waypoint>
            </div>

          <div className="col-lg-3 col-md-6 d-md-flex align-items-md-stretch">
              <Waypoint
                onEnter={() => handleEnterViewport("count3")}
                onLeave={() => handleLeaveViewport("count3")}
              >
                <div className="count-box">
                  <i className="bi bi-piggy-bank"></i>
                  {countUpInView.count3 && (
                    <CountUp
                      end={32}
                      duration={1}
                      prefix="M$ "
                      decimals={0}
                      className="purecounter"
                    />
                  )}
                  <p>
                    <strong>Revenue</strong>
                    <br />
                    Through strategic initiatives and effective management, I have contributed to generating over thirty million dollars in revenue for various organizations.
                  </p>
                </div>
              </Waypoint>
            </div>

            <div className="col-lg-3 col-md-6 d-md-flex align-items-md-stretch">
              <Waypoint
                onEnter={() => handleEnterViewport("count1")}
                onLeave={() => handleLeaveViewport("count1")}
              >
                <div className="count-box">
                  <i className="bi bi-clock-history"></i>
                  {countUpInView.count1 && (
                    <CountUp
                      end={22}
                      duration={1}
                      prefix=""
                      decimals={0}
                      className="purecounter"
                    />
                  )}
                  <p>
                    <strong>Years of Experience</strong>
                    <br />
                    With over two decades of professional experience, I bring a wealth of expertise to every project.
                  </p>
                </div>
              </Waypoint>
            </div>

            <div className="col-lg-3 col-md-6 d-md-flex align-items-md-stretch">
              <Waypoint
                onEnter={() => handleEnterViewport("count4")}
                onLeave={() => handleLeaveViewport("count4")}
              >
                <div className="count-box">
                  <i className="bi bi-award"></i>
                  {countUpInView.count4 && (
                    <CountUp
                      end={12}
                      duration={1}
                      prefix=""
                      decimals={0}
                      className="purecounter"
                    />
                  )}
                  <p>
                    <strong>Awards</strong>
                    <br />
                    Recognized for excellence in my field, I have received over ten industry awards, showcasing my dedication to quality and innovation.
                  </p>
                </div>
              </Waypoint>
            </div>
          
        </div>
      </div>
    </section>
  );
};

export default Facts;
